import Papa from 'papaparse';
import Encoding from 'encoding-japanese';

/**
 * 数値であるかを判定
 * @param {any} value 確認する値
 * @returns {boolean} true:数値である、false:数値ではない
 */
export function isNumber(value) {
  return Number.isFinite(value);
}

/**
 * SJISで文字列の切り取り
 * @param {string} text 文字列
 * @param {number} start 開始バイト位置(1～)
 * @param {number} length バイト長
 * @returns {string} 切り取り文字列
 */
export function substring_sjis(text, start, length) {
  const sjisBytes = Encoding.convert(text, { to: 'SJIS', from: 'UNICODE', type: 'array' });
  const sliced = sjisBytes.slice(start - 1, start + length - 1);
  return Encoding.convert(sliced, { to: 'UNICODE', from: 'SJIS', type: 'string' });
}

/**
 * SJISで文字列長の取得
 * @param {string} text 文字列
 * @returns {number} バイト長
 */
export function length_sjis(text) {
  const bytes = Encoding.convert(text, {
    to: 'SJIS',
    from: 'UNICODE',
    type: 'array'
  });
  return bytes.length;
}

/**
 * CSVデータを解析
 * @param {!any} fileContent CSVファイル
 * @param {string} delimiter 区切り文字
 * @param {boolean} header true:ヘッダあり
 * @returns {?any} 解析データ
 */
export async function csvParse(fileContent, delimiter, header) {
  return new Promise((resolve) => {
    Papa.parse(fileContent, {
      header: false,
      delimiter: delimiter,
      newline: '\r\n',
      quoteChar: '"',
      escapeChar: '"',
      skipFirstNLines: header ? 1 : 0,
      encoding: 'shift-jis',
      skipEmptyLines: true,
      complete: function (results) {
        resolve(results.data);
      }
    });
  });
}
